<template>
  <loading-data-page-container :loading="loading"
                               :loading-error="loadingError"
                               :loading-error-message="loadingErrorMsg">

    <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

      <vertrags-header v-if="data"
                       :vertragsnummer="data.Vertragsnummer"
                       :kunden-name="data.Vorname + ' ' + data.Name"
                       page-name="Vertragsdaten">
        <div slot="details-right">
          <v-btn v-if="allowEditVertrag(data)"
                 color="primary"
                 outlined
                 text
                 @click="editContract">
            <v-icon>subject</v-icon>
            Vertrag ändern
          </v-btn>

          <v-btn v-if="!hideExcelDownload"
                 color="primary"
                 class="ml-2"
                 @click="exportExcel">
            <v-icon>file_download</v-icon>
            EXCEL
          </v-btn>
        </div>
      </vertrags-header>

      <details-section :items="generalItems"
                       divider />

      <details-section :items="vertragsdetailsItems"
                       :alternativelink="getSchaedenDetailsLink()"
                       :divider="!hideCourtagen"
                       title="Vertragsdetails">
        <!--  <template slot="value"
                  slot-scope="{ item }">
          <td v-if="item.label === 'Versicherungsumfang'"
              class="value-data-cell">
            <versicherungsumfang :categories="item.value" />
          </td>
        
           <td v-else-if="item.valueTooltip"
              class="value-data-cell">
            <v-tooltip top
                       nudge-bottom="8"
                       content-class="detailstable-tooltip">
              <template v-slot:activator="{on}">
                <span v-on="on">{{ getValueText(item) }}</span>
              </template>
              <span class="caption">{{ item.valueTooltip }}</span>
            </v-tooltip>
          </td>
          <td v-else
              class="value-data-cell">{{ getValueText(item) }}
          </td>
        </template>-->
      </details-section>

      <details-section v-if="!hideCourtagen"
                       :items="courtageItems"
                       title="Courtage" />

      <div v-if="this.$route.params['backTo'] === 'BestandDetailPage'"
           class="back-btn">
        <v-btn color="primary white--text"
               @click="goBack"> Zurück
        </v-btn>
      </div>

    </v-container>

  </loading-data-page-container>
</template>
<script>
import DetailsSection from "@/components/userProfile/DetailsSection";
import httpService from '@/helper/httpService';
import dummyData from "@/store/dummyData/bestandDummyData";
import ParsingMixin from '@/pages/kundenverwaltung/ParsingMixin';
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import VertragsHeader from '@/components/kundenverwaltung/VertragsHeader';
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";

import {CONNECTION_ERROR_MESSAGE} from "@/helper/httpService";
//import Versicherungsumfang from "@/components/kundenverwaltung/Versicherungsumfang";
import {RIGHTS} from "@/store/user";

export default {
  name: "BestanddetailPage",
  components: { LoadingDataPageContainer, DetailsSection, VertragsHeader },
  mixins: [ParsingMixin, ExcelMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      data: this.$route.params['data']
    };
  },
  computed: {
    generalItems: function () {
      return [
        { label: "Straße", value: this.data.Strasse },
        { label: "PLZ, Ort", value: this.data.PLZ + " " + this.data.Ort },
        { label: "Geburtsdatum", value: this.data.Geburtsdatum }];
    },
    vertragsdetailsItems: function () {
      let ret = [
        { label: "Produkt", value: this.data.produkt },
        { label: "Versicherungsumfang", value: this.data.umfang },
        { label: "Deckungen", value: this.data.deckung , multiline:true},
        { label: "Deckungssumme", value: this.$helpers.formatCurrencyDeckung(this.data.Deckungssumme) },
        { label: "Selbstbeteiligung", value: this.$helpers.formatCurrencySb(this.data.Selbstbehalt) },
        { label: "Haushalt", value: this.data.Haushalt },
        {
          label: "Mitversicherte",
          value: this.data.mvp ? this.data.mvp.firstname + " " + this.data.mvp.lastname : ( this.data.Mitversicherte ? this.data.Mitversicherte : "Keine Angabe")
        },
        { label: "Vetragsbeginn", value: this.data.Beginn },
        { label: "Vertragsende", value: this.data.Ende }];
        if(this.data.HauptF) {ret.push({ label: "Hauptfälligkeit", value: this.data.HauptF });}
        ret.push({ label: "Jahresbeitrag", value: /^0,0/.test(this.$helpers.formatCurrency(this.data.Beitrag)) ? '' : this.$helpers.formatCurrency(this.data.Beitrag) });
        ret.push({ label: "Zahlweise", value: this.$helpers.formatKomma(this.data.Zahlungsweise) });
        ret.push({ label: "Mahnstatus", value: this.data.Mahnstatus });
        ret.push({ label: "Schäden", value: this.data.Schaeden });
        return ret;
    },
    courtageItems: function () {
      return [
        { label: "Courtage gezahlt", value: this.$helpers.formatCurrency(this.data.ProvisionKumuliert) },
        { label: "Courtage offen", value: this.$helpers.formatCurrency(this.data.ProvisionAktuell) }];
    },
    hideExcelDownload () {
      return !this.$store.getters.checkAuthorization(RIGHTS.EXCEL);
    },
    hideCourtagen () {
      return !this.$store.getters.checkAuthorization(RIGHTS.COURTAGEN);
    }
  },
  created() {
    // Only if data is not passed through routing then query backend
    if (!this.data) {
      httpService.getVertrag(this.$route.params['vertragsnummer'], this.$route.params['vmnr'])
        .then(vertrag => {
          this.data = this.parseProduct(vertrag);
          this.loading = false;
        })
        .catch(err => {
          console.log(`GET CONTRACTS failed with ${err.status}: ${err.message}`);
          //TODO delete dummy data for production
          if (this.$store.state.env.environment === 'development') {
            this.data = dummyData.map(this.parseProduct)
              .filter(item => item.Vertragsnummer === this.$route.params['vertragsnummer']).pop();
            this.loading = false;
          } else {
            this.loadingErrorMsg = err.status < 500 ? 'Vertrag nicht gefunden' : CONNECTION_ERROR_MESSAGE;
            this.loadingError = true;
            this.loading = false;
          }
        });
    } else {
      this.data = this.parseProduct(this.data);
      this.loading = false;
    }
  },
  methods: {
    //todo delete this when we get product column from backend
    parseProduct: function (vertrag) {
      const produktInformation = this.deriveProduktInformation(vertrag);
      return {
        ...vertrag,
        ...produktInformation
      };
    },
    getSchaedenDetailsLink() {
      return {
        text: 'Zur Schadenübersicht',
        target: {
          name: this.$route.params.vmnr ? 'VLSchadenDetailPage' : 'SchadenDetailPage',
          params: {
            vertragsnummer: this.$route.params.vertragsnummer,
            vmnr: this.$route.params.vmnr,
            backTo: 'Bestanddetails'
          }
        },
        newPage: true
      };
    },
    goBack: function () {
      window.history.back();
    },
    editContract: function () {
      this.$store.dispatch('resetAenderungsData');
      let route = {
        name: 'AenderungsantragPage',
        params: {
          vertragsnummer: this.$route.params['vertragsnummer'],
          vertrag: this.data,
          backTo: 'Bestanddetails'
        }
      };
      this.$router.push(route);
    },
    exportExcel() {
      this.generateExcel([].concat(this.formatBestandDataForExcel(this.data)), this.columnFormatBestandDataForExcel(), "Vertr-Nr-" + this.$route.params['vertragsnummer']);
    }
  }
};
</script>

<style>
.details-table .versicherungsumfang {
  max-width: fit-content;
  margin-left: auto;
}
</style>
